import { createCircleOrOblongShape } from "../primitives/createCircleOrOblongShape";
import { createShapeFromSvgPath } from "./createShapeFromSvgPath";
export function createSvgShape(boardShapeValue, hole, opts = {}) {
    const shapeExpressionMatch = boardShapeValue.match(/=([a-zA-Z]+)\("([^"]*)"\)/);
    let shape;
    if (shapeExpressionMatch) {
        const [, shapeFunction, shapeString] = shapeExpressionMatch;
        switch (shapeFunction) {
            case "svgPath":
                shape = createShapeFromSvgPath(shapeString, { yIsUp: false, ...opts })?.clone();
                break;
            case "svgPathYIsUp":
                shape = createShapeFromSvgPath(shapeString, { yIsUp: true, ...opts })?.clone();
                break;
            default:
                shape = undefined;
        }
    }
    else {
        // Fallback to old behavior of SVG string directly in the rule content, treating
        // Y axis as positive-up. However, this format is deprecated.
        // Note that SVG Paths are *not* centered - this is an important detail that is a
        // by design decision:
        // https://github.com/buildwithflux/flux-app/pull/4590/#pullrequestreview-1333295024)
        if (boardShapeValue) {
            try {
                shape = createShapeFromSvgPath(boardShapeValue, opts)?.clone();
            }
            catch (e) {
                opts.logger?.captureError(e, { notifyUserMessage: "Failed to create shape from SVG path." });
                shape = undefined;
            }
        }
        else {
            shape = undefined;
        }
    }
    if (shape && hole?.holeSize) {
        const holeShape = createCircleOrOblongShape(hole.holeSize, hole.holePosition ?? { x: 0, y: 0 }, undefined, 128);
        shape.holes.push(holeShape);
    }
    return shape;
}
//# sourceMappingURL=createSvgShape.js.map